import { useState, useLayoutEffect, useEffect } from 'react'

export const useWindowSize = () => {
    const [size, setSize] = useState([
        typeof window !== 'undefined' ? window.innerWidth : 0,
        typeof window !== 'undefined' ? window.innerHeight : 0
    ])
    const useIsomorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
    
    useIsomorphicEffect(() => {
        if (typeof window === 'undefined') return
        
        const onResize = () => {
            setSize([window.innerWidth, window.innerHeight])
        }
        window.addEventListener('resize', onResize)
        onResize()
        return () => window.removeEventListener('resize', onResize)
    }, [])
    return size
}
